import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabel, heroImage, trackCheckout } from '../data/offer';
const highlights = ['Premium Coaching System', '5 strategic bonuses', 'Immediate access'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-base" data-id="element-139" data-mp="4n1k6o86i6qx">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-cream via-base to-base -z-10" data-id="element-140" data-mp="128frdnreylxt" />
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-141" data-mp="x8b8xs6y3h4y">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-142" data-mp="s9q6dm480ldc">
          <div className="inline-block px-3 py-1 rounded-full border border-brand/30 bg-brand-soft text-brand-dark font-semibold text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-143" data-mp="3d2tqbf4z2uh6">
            🏆 Ninja Coach Ready
          </div>
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-extrabold leading-tight mb-4 sm:mb-6 text-ink" data-id="element-144" data-mp="3o85bzdbr655m">
            Solve an entire year of Ninja classes in just{' '}
            <span className="text-brand" data-id="element-145" data-mp="3e8wjkowjcyld">5 minutes.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-[320px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-146" data-mp="30iawsp3yo4i7">
          <img src={heroImage} alt="Ninja Coach Ready — 150 ready-to-teach Ninja lessons, 6 complete volumes and 5 bonuses" className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-147" data-mp="2violwmblv0ck" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-148" data-mp="2lk8u0h4r7n20">
          <p className="text-sm sm:text-lg md:text-xl text-graphite leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-149" data-mp="n98ebq63t9oy">
            Ninja Coach Ready — Complete coaching system. The complete professional coaching system
            — ready to use from today.
          </p>
          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-150" data-mp="1azkufobi6cqm">
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-151" data-mp="1622j5ra0jlfg">
              {ctaLabel}
            </Button>
          </div>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-graphite-light" data-id="element-152" data-mp="3lsp49g06snfh">
            {highlights.map(highlight => <div key={highlight} className="flex items-center gap-1.5" data-id="element-153" data-mp="3hq27r1skmeby">
                <CheckCircle size={14} className="text-brand" data-id="element-154" data-mp="1xam54pmyxoye" />
                <span data-id="element-155" data-mp="21aej5hv4snb5">{highlight}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}